<script>
	export let data;

	import { slide } from "svelte/transition";
	import { cloneDeep } from "lodash-es";

	import Inputs from "../simple/Inputs.svelte";
	import { isMobile, currentEntityID } from "../../../../stores/variables";
	import { getNoun } from "../../../../scripts/get_noun";
	import { request } from "../../../../scripts/request";

	let reviews;
	let inputsData = {
		field_names: ["Answer"],
		maxlength: 255,
		inputs: [
			{
				description: "Официальный ответ",
				value: "",
				field_name: "Answer",
				type: "text",
				required: true,
			},
		],
		newData: [],
	};
	let months = [
		"января",
		"февраля",
		"марта",
		"апреля",
		"мая",
		"июня",
		"июля",
		"августа",
		"сентября",
		"октября",
		"ноября",
		"декабря",
	];

	function countWidth(num) {
		let diff = Math.round((data.ratings.average - num) * 10);
		let first = 10 + (diff - 5) * 2;
		let second = 30 - first;
		return String(first) + " " + String(second);
	}
	function butifyDate(fulldate) {
		let date = fulldate.split(" ")[0].split("-");
		let year = date[0];
		let month = +date[1];
		let day = date[2];
		let raw = day + " " + months[month - 1] + " " + year;
		return raw;
	}
	function sendReply(target, id) {
		let value = target.parentNode.querySelector("input").value;
		if (!value) {
			target.classList.add("no");
		} else {
			let d2 = {
				id: +id,
				text: value,
			};
			let temp = request.sendObjData(d2, "replydata", "replyComment");
		}
	}
	if (data) {
		data.ratings = {
			summ: 0,
			count: 0,
			average: 0,
			marks: [0, 0, 0, 0, 0],
			percentage: [0, 0, 0, 0, 0],
			circles: {
				bottom: {
					dashoffset: "-6",
					dasharray:
						"20 10 20 10 20 10 20 10 20 10 20 10 20 10 20 10 20 10 20 10",
				},
				middle: {
					dashoffset: "-6",
					dasharray: "0 300",
				},
				top: {
					dashoffset: "-6",
					dasharray: "0 300",
				},
			},
		};

		if (!data.reviews) data.reviews = [];
		if (!data.newData) data.newData = [];
		if (!data.newData[data.field_name]) data.newData[data.field_name] = [];

		if (data.newData && data.newData[data.field_name]) {
			// data.reviews = data.newData[data.field_name];

			data.newData[data.field_name].forEach((item) => {
				if (item.Parent == 0) {
					let temp = cloneDeep(item);
					data.reviews.push(temp);
				}
			});
			data.reviews.forEach((item, i) => {
				data.newData[data.field_name].forEach((subitem) => {
					if (item.ID == subitem.Parent) {
						if (!item.replies) item.replies = [];
						let temp = cloneDeep(subitem);
						item.replies.push(temp);
					}
				});
			});

			let ids = [];

			data.reviews.forEach((review) => {
				data.ratings.marks[review.Rating - 1]++;
				data.ratings.summ += +review.Rating;
				data.ratings.count++;

				ids.push(review.ID);
			});

			if (ids && ids.length > 0) {
				let d = {
					id: +$currentEntityID,
					data: ids,
				};
				request.fetchData(
					"ReviewsCounterUpdate",
					"ReviewsCounterUpdate",
					d
				);
			}

			if (data.ratings.count) {
				data.ratings.average = data.ratings.summ / data.ratings.count;
				data.ratings.marks.forEach((mark, i) => {
					data.ratings.percentage[i] =
						data.ratings.marks[i] / data.ratings.count;
				});
			}

			if (data.ratings.average == 5) {
				data.ratings.circles.middle.dasharray =
					"20 10 20 10 20 10 20 10 20 10 20 10 20 10 20 10 20 10 20 10";
			} else if (data.ratings.average > 4) {
				data.ratings.circles.middle.dasharray =
					"20 10 20 10 20 10 20 10 20 10 20 10 20 10 20 10 20 10 " +
					countWidth(4);
			} else if (data.ratings.average > 3) {
				data.ratings.circles.middle.dasharray =
					"20 10 20 10 20 10 20 10 20 10 20 10 20 10 20 10 " +
					countWidth(3) +
					" 0 30";
				data.ratings.circles.top.dashoffset = "-276";
			} else if (data.ratings.average > 2) {
				data.ratings.circles.middle.dasharray =
					"20 10 20 10 20 10 20 10 20 10 20 10 20 10 " +
					countWidth(2) +
					" 0 30 0 30";
				data.ratings.circles.top.dasharray = "0 30 0 30 300";
				data.ratings.circles.top.dashoffset = "-246";
			} else if (data.ratings.average > 1) {
				data.ratings.circles.middle.dasharray =
					"20 10 20 10 20 10 20 10 20 10 20 10 " +
					countWidth(1) +
					" 0 30 0 30 0 30";
				data.ratings.circles.top.dasharray = "0 30 0 30 0 30 300";
				data.ratings.circles.top.dashoffset = "-216";
			} else if (data.ratings.average > 0) {
				data.ratings.circles.middle.dasharray =
					"20 10 20 10 20 10 20 10 20 10 " +
					countWidth(0) +
					" 0 30 0 30 0 30 0 30";
				data.ratings.circles.top.dasharray = "0 30 0 30 0 30 0 30 300";
				data.ratings.circles.top.dashoffset = "-186";
			}
		}

		if (reviews) {
			let temp = reviews.querySelectorAll(".review__text");
			if (temp) {
				temp.forEach((raw) => {
					if (raw.clientHeight < raw.scrollHeight) {
						raw.classList.add("review__text-big");
						raw.style.height = raw.clientHeight + "px";
						raw.querySelector("div").style.height = "50px";
					}
				});
			}
		}
	}
</script>

{#if data}
	<div class="reviews" bind:this={reviews}>
		<div class="reviews__blank">
			<div class="review__text-big">
				<div>
					<span />
				</div>
			</div>
		</div>
		<div class="reviews__content">
			{#if data.name}
				<h3>{data.name}</h3>
			{/if}
			{#if data.reviews}
				{#each data.reviews as review, i}
					<div class="reviews__review review">
						<div class="review__header">
							<div class="review__logo">
								<img src="/img/user.svg" alt="" />
							</div>
							<div class="review__header-body">
								<span class="review__person"
									>{review.Person}</span
								>
								<div class="review__info">
									<span class="review__rating">
										{#each data.ratings.marks as star, i}
											{#if review.Rating > i}
												<i class="fas fa-star" />
											{:else}
												<i
													class="fas fa-star"
													style="font-weight: 400;"
												/>
											{/if}
										{/each}
									</span>
									<span class="review__date"
										>{butifyDate(review.Created)}</span
									>
								</div>
							</div>
						</div>
						<div
							class="review__text scrollbar-white {$isMobile
								? 'mobile'
								: 'not_mobile'}"
							style="max-height: 200px;"
						>
							{@html review.Text}
							<div
								on:click={(e) => {
									let parent = e.target.parentNode;
									parent.style.height =
										parent.scrollHeight - 50 + "px";
									parent.style.maxHeight =
										parent.scrollHeight - 50 + "px";
									e.target.style.height = "0px";
									setTimeout(() => {
										e.target.style.display = "none";
									}, 300);
								}}
							>
								<span>Развернуть</span>
							</div>
						</div>
						{#if review.replies}
							<!-- <div class="review__replies" transition:slide> -->
							<div class="review__replies">
								{#each review.replies as reply}
									<div class="review__reply reply">
										<div class="reply__logo">
											<img src="/img/user.svg" alt="" />
										</div>
										<div class="reply__body">
											<div class="reply__header">
												{#if reply.IsOfficial}
													<span class="reply__title"
														>Официальный ответ</span
													>
												{:else if reply.Person}
													<span class="reply__title"
														>{reply.Person}</span
													>
												{:else}
													<span class="reply__title"
														>Без имени</span
													>
												{/if}
												{#if reply.Created}
													<span class="reply__date"
														>{butifyDate(
															reply.Created
														)}</span
													>
												{/if}
											</div>
											<div class="reply__content">
												<span>{reply.Text}</span>
											</div>
										</div>
									</div>
								{/each}
							</div>
						{/if}
						<!-- <div class="review__answer" transition:slide> -->
						<div class="review__answer">
							<div class="review__logo">
								<img src="/img/user.svg" alt="" />
							</div>
							<div class="review__input">
								<svelte:component
									this={Inputs}
									data={inputsData}
									noNeedToChange={true}
								/>
								<span
									class="review__send fas fa-reply"
									title="Отправить"
									on:click={(e) => {
										let now = new Date()
											.toISOString()
											.slice(0, 10);
										review.replies = [];
										review.replies[0] = {
											Created: now,
											Text: e.target.parentNode.querySelector(
												"input"
											).value,
										};
										sendReply(e.target, review.ID);
									}}
								/>
							</div>
						</div>
					</div>
				{/each}
			{/if}
		</div>
		<div class="reviews__ratings">
			<div class="reviews__average">
				<svg viewBox="0 0 100 50"
					><circle
						r="48"
						cx="50"
						cy="50"
						fill="transparent"
						stroke="#eee"
						stroke-width="4"
						stroke-dasharray={data.ratings.circles.bottom.dasharray}
						stroke-dashoffset={data.ratings.circles.bottom
							.dashoffset}
						stroke-linecap="round"
					/><circle
						r="48"
						cx="50"
						cy="50"
						fill="transparent"
						stroke="#3398d4"
						stroke-width="4"
						stroke-dasharray={data.ratings.circles.middle.dasharray}
						stroke-dashoffset={data.ratings.circles.middle
							.dashoffset}
						stroke-linecap="round"
					/>
					<circle
						r="48"
						cx="50"
						cy="50"
						fill="transparent"
						stroke="#eee"
						stroke-width="4.2"
						stroke-dasharray={data.ratings.circles.top.dasharray}
						stroke-dashoffset={data.ratings.circles.top.dashoffset}
						stroke-linecap="round"
					/></svg
				>
				<span>{data.ratings.average.toFixed(1)}</span>
			</div>
			<div class="reviews__title">
				<h5>Распределение оценок</h5>
				<span
					>{data.ratings.count}
					{getNoun(data.ratings.count, "оценка", "оценки", "оценок")} и
					отзывов</span
				>
			</div>
			<div class="reviews__percentage">
				{#each data.ratings.percentage as mark, i}
					<div class="mark">
						<span class="mark__count">{i + 1}</span>
						{#if !mark}
							<i
								class="fas fa-star mark__star"
								style="font-weight:400"
							/>
						{:else}
							<i class="fas fa-star mark__star" />
						{/if}
						<div class="mark__scale">
							<span
								class="mark__scale-color"
								style="width: {mark * 100}%;"
							/>
							<span class="mark__scale-gray" />
						</div>
					</div>
				{/each}
			</div>
		</div>
	</div>
{/if}

<style lang="scss">
	.mark {
		display: flex;
		font-size: 14px;
		&__count {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 12px;
			margin-right: 2px;
		}
		&__star {
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 12px;
			margin-right: 6px;
			color: var(--color-2);
		}
		&__scale {
			display: flex;
			position: relative;
			align-items: center;
			flex-grow: 1;
			> span {
				display: flex;
				border-radius: 10px;
			}
			&-color {
				position: absolute;
				height: 40%;
				background-color: var(--color-2);
			}
			&-gray {
				height: 39%;
				width: 100%;
				background-color: #ecedf1;
			}
		}
	}
	.reviews {
		display: flex;
		@media (min-width: 992px) {
			max-width: var(--module-width-1);
		}
		@media (max-width: 991px) {
			flex-direction: column-reverse;
		}
		&__blank {
			display: none;
			position: absolute;
			z-index: -100;
			height: 0;
			width: 0;
			cursor: none;
			pointer-events: none;
		}
		&__title {
			display: flex;
			flex-direction: column;
			align-self: center;
			margin-top: 6px;
			> h5 {
				display: flex;
				align-items: center;
				justify-content: center;
				text-align: center;
				font-size: 16px;
			}
			> span {
				display: flex;
				align-items: center;
				justify-content: center;
				text-align: center;
				font-size: 14px;
				margin-top: 3px;
				color: var(--text-gray-1);
			}
		}
		&__content {
			display: flex;
			flex-direction: column;
			flex-grow: 1;
			@media (min-width: 992px) {
				margin-right: 15px;
			}
		}
		&__ratings {
			display: flex;
			flex-direction: column;
			align-self: flex-start;
			flex-shrink: 0;
			padding: 15px;
			border: solid 1px #f1f1f1;
			border-radius: 20px;
			@media (max-width: 991px) {
				align-self: center;
				max-width: 360px;
				width: 100%;
				margin-bottom: 12px;
			}
		}
		&__average {
			position: relative;
			display: flex;
			flex-direction: column;
			height: 100px;
			width: 200px;
			justify-content: center;
			align-items: center;
			align-self: center;
			> span {
				position: absolute;
				bottom: 2px;
				font-size: 50px;
				color: var(--text-black-1);
			}
		}
		&__percentage {
			display: flex;
			flex-direction: column-reverse;
			margin-top: 12px;
		}
	}
	.review {
		display: flex;
		flex-direction: column;
		padding: 15px;
		border: solid 1px #f1f1f1;
		border-radius: 20px;
		margin-bottom: 6px;
		&__header {
			display: flex;
			&-body {
				display: flex;
				flex-direction: column;
			}
		}
		&__logo {
			display: flex;
			height: 40px;
			width: 40px;
			border: 1px solid #00000014;
			border-radius: 50%;
			margin-right: 12px;
			> img {
				display: flex;
				height: 100%;
				width: 100%;
				object-fit: cover;
			}
		}
		&__info {
			margin-top: 6px;
			display: flex;
			flex-wrap: wrap;
			align-items: center;
		}
		&__rating {
			font-size: 12px;
			color: var(--color-2);
			margin-right: 4px;
		}
		&__date {
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 14px;
			color: var(--text-gray-1);
		}
		&__text {
			font-size: 14px;
			margin-top: 12px;
			line-height: 1.3;
			padding-right: 15px;
			padding-left: 52px;
			transition: all 0.3s ease;
			> div {
				display: none;
				transition: all 0.3s ease;
				> span {
					display: none;
					pointer-events: none;
				}
			}
			&-big {
				position: relative;
				> div {
					display: flex;
					align-items: flex-end;
					position: sticky;
					bottom: 0;
					left: 0;
					width: 100%;
					height: 50px;
					background-image: linear-gradient(0deg, #fff, #ffffff52);
					cursor: pointer;
					> span {
						display: flex;
						border-bottom: 1px dashed var(--color-1);
						margin-bottom: 1px;
						color: var(--color-1);
					}
				}
			}
		}
		&__answer {
			padding: 15px 0 0 0;
			display: flex;
			align-items: center;
		}
		&__input {
			flex-grow: 1;
			display: flex;
			flex-direction: column;
			position: relative;
		}
		&__send {
			position: absolute;
			margin-left: 12px;
			display: flex;
			align-items: center;
			justify-content: center;
			flex-shrink: 0;
			cursor: pointer;
			width: 44px;
			height: 44px;
			color: var(--color-1);
			right: 0;
			top: 4px;
		}
		&__replies {
			display: flex;
			flex-direction: column;
			padding: 15px 0 0 0;
		}
		&__reply {
			margin-top: 15px;
			&:first-child {
				margin-top: 0;
			}
		}
	}
	.reply {
		display: flex;
		&__body {
			width: 100%;
			display: flex;
			flex-direction: column;
			background: #e9e9e9;
			border-radius: 12px;
		}
		&__header {
			padding: 6px 10px;
			font-size: 13px;
			background: #e9e9e9;
			border-top-right-radius: 12px;
		}
		&__date {
			color: #999;
		}
		&__content {
			padding: 8px 12px;
			font-size: 13px;
			border-radius: 12px;
			border-top-left-radius: 0;
			background: #f5f5f5;
		}
		&__logo {
			display: flex;
			height: 40px;
			width: 40px;
			border: 1px solid #00000014;
			border-radius: 50%;
			margin-right: 12px;
			> img {
				display: flex;
				height: 100%;
				width: 100%;
				object-fit: cover;
			}
		}
	}
</style>
